import { useAnimations, useGLTF } from "@react-three/drei";
import { useEffect, useContext, useRef } from "react";
import { ViewContext } from "../../../../../providers/View.provider";
import gsap from "gsap";

export default function SpongeBob() {
  const spongeBobModel = useGLTF("/models/spongebob.glb");
  const spongeBobAnimations = useAnimations(spongeBobModel.animations, spongeBobModel.scene);
  const spongeBobRef = useRef();
  const { delayNodes } = useContext(ViewContext);
  useEffect(() => {
    gsap.fromTo(
      spongeBobRef.current.scale,
      { x: 0, y: 0, z: 0 },
      { x: 0.7, y: 0.7, z: 0.7, delay: (delayNodes * 0.1) / 2 }
    );
    spongeBobAnimations.actions["spongebob_jjk_spongebob_skeleton|Jump 2"].play();
  }, []);

  return <primitive ref={spongeBobRef} object={spongeBobModel.scene} position={[5, 1.4, -30.4]} scale={0.7} />;
}
